import React from "react";
import Button from "./Button";
import useDarkMode from "../hooks/useDarkMode";
import { useFormCtx } from "./../FormContext";
import * as Const from "./../_Const";

const DebugPage = ({ terminal, uid, keyNumber }) => {
  const { handleDebug, navigateToServicePage, handleAnimationDisabled, isAnimationDisabled, setDarkMode, runRestartOrShutdown } = useFormCtx();
  const [isDarkMode, toggleTheme] = useDarkMode();
  const textAnimation = isAnimationDisabled ? "Animace Zapnout" : "Animace Vypnout";
  const textDarkLightMode = isDarkMode ? "Nastavit Světlý řežim" : "Nastavit Tmavý řežim";

  function handleDarkMode() {
    setDarkMode(!isDarkMode);
    toggleTheme();
  }
  return (
    <>
      <div className="mt-2 mx-6 text-2xl dark:text-accent text-accent-dark">
        Klíč: {keyNumber} - Terminal: {terminal} - Mobile UID: {uid}
      </div>
      <div className="grid grid-cols-4 mt-6 gap-4 mx-4">
        <Button title={textDarkLightMode} showIcon={false} className="h-20" onClick={handleDarkMode} />
        <Button title={textAnimation} showIcon={false} className="h-20" onClick={() => handleAnimationDisabled(!isAnimationDisabled)} />
        <Button title="Test Page" showIcon={false} onClick={() => navigateToServicePage(Const.PAGE_TEST)} className="h-20" />
      </div>
      <div className="grid grid-cols-4 mt-4 gap-4 mx-4">
        <Button title="Restart" showIcon={false} type="clickonce" className="h-20" onClick={() => runRestartOrShutdown(Const.OPERATION_RESTART)} />
        <Button title="Vypnout" showIcon={false} type="clickonce" className="h-20" onClick={() => runRestartOrShutdown(Const.OPERATION_SHUTDOWN)} />
      </div>
      <div className="absolute right-6 bottom-8">
        <Button title="Ukončit DEBUG Mode" type="error-dark" showIcon={false} onClick={handleDebug} className="h-20" />
      </div>
    </>
  );
};

export default DebugPage;
